module.exports = __webpack_public_path__ + "static/media/link.5da459e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/link.svg
// module id = 1224
// module chunks = 0